<template>
    <div id="header" :class="{ 'navBarShadow': scrollType && is_PC }">
        <!-- PC端样式 -->
        <div class="wrapper" v-if="is_PC">
            <div class="content">
                <div id="headTop">
                    <a href="/" id="logo">
                        <img :src="enterprisesInformation.EnterprisesLogo" height="72" />
                    </a>

                    <!-- logo -->
                    <!-- 联系方式 -->
                    <div id="hcontact" v-if="enterprisesInformation">
                        <i class="el-icon-phone"></i>
                        <p>
                            <span class="telNum">{{ enterprisesInformation.EnterprisesPhone }}</span><br />
                            <a :href="'mailto:' + enterprisesInformation.EnterprisesEmail">{{
        enterprisesInformation.EnterprisesEmail }}</a>
                        </p>
                    </div>
                    <!-- 联系方式 -->
                    <!-- 搜索栏 -->
                    <div id="search-header" class="searchGroup">
                        <div class="search_wrap">
                            <!-- <div class="searchOnOff">
                            <i class="el-icon-search" aria-hidden="true"></i>
                        </div> -->

                            <div class="searchBox">
                                <div class="searchFormGroup">
                                    <el-input v-model="searchVal" type="text" aria-label="搜索" placeholder="请输入搜索内容"
                                        autocorrect="off" autocapitalize="off" autocomplete="off" spellcheck="false"
                                        @keyup.enter.native="toSearch()" prefix-icon="el-icon-search"></el-input>
                                    <!-- <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="searchVal" > -->

                                    <!-- @keyup.enter.native="toSearch()" -->
                                    <div class="searchSub" @click="toSearch"><span>搜索</span><i class="fa fa-search"
                                            aria-hidden="true"></i></div>
                                </div>
                                <div class="searchClose"><i class="fa fa-times" aria-hidden="true"></i></div>
                            </div>
                        </div>
                    </div>
                    <!-- 搜索栏 -->
                    <!-- 打开按钮 -->
                    <div id="openBtn" class="fl btn">
                        <div class="lcbody">
                            <div class="lcitem top">
                                <div class="rect top"></div>
                            </div>
                            <div class="lcitem center hide">
                                <div class="rect bottom"></div>
                            </div>
                            <div class="lcitem bottom">
                                <div class="rect bottom"></div>
                            </div>
                        </div>
                    </div>
                    <!-- 打开按钮 -->
                </div>

                <!-- </transition> -->
                <!-- 菜单 -->
                <div class="nav">
                    <el-menu :default-active="onRoutes" class="el-menu-demo" mode="horizontal" @select="handleSelect"
                        router>
                        <el-menu-item index="/home">首页</el-menu-item>
                        <el-menu-item index="/course">产品中心</el-menu-item>
                        <el-menu-item index="/news">新闻中心</el-menu-item>
                        <el-menu-item index="/contactUs">联系我们</el-menu-item>
                    </el-menu>
                </div>
                <!-- 菜单 -->
            </div>
        </div>
        <!-- PC端样式 -->
        <!-- 移动端样式 -->
        <div class="m-wrapper" v-if="!is_PC">
            <div class="m-menu" @click="drawer = !drawer" v-if="!is_return"><i class="el-icon-s-operation"></i></div>
            <div class="m-menu" @click="returnBtn()" v-if="is_return"><i class="el-icon-back"></i></div>
            <div class="m-logo"><img :src="enterprisesInformation.EnterprisesLogo" alt="">
            </div>
            <div class="m-search" @click="is_m_search = !is_m_search"><i class="el-icon-search"></i></div>
        </div>

        <transition name="m-search-show">
            <div class="m-search-box" v-if="is_m_search">
                <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="searchVal"
                    @keyup.enter.native="toSearch()">
                </el-input>
            </div>
        </transition>

        <transition name="m-mark-show">
            <div class="m-mark" @click="is_m_search = false" v-if="is_m_search"></div>
        </transition>

        <el-drawer v-if="!is_PC" :visible.sync="drawer" direction="ltr" :before-close="handleClose" size='80%'
            style="height:100%;" :modal="false">
            <el-menu :default-active="onRoutes" class="el-menu-m" mode="vertical" @select="handleSelect" router>
                <el-menu-item index="home">首页</el-menu-item>
                <el-menu-item index="course">产品中心</el-menu-item>
                <el-menu-item index="news">新闻中心</el-menu-item>
                <el-menu-item index="contactUs">联系我们</el-menu-item>
            </el-menu>
        </el-drawer>
        <!-- 移动端样式 -->

    </div>
</template>

<script>
export default {
    data() {
        return {
            muenindex: this.$route.path.replace("/", ""),
            //获取当前登录设备
            is_PC: this.$store.state.is_PC,
            ip: this.$store.state.ip,
            //抽屉开关
            drawer: false,
            //是否显示搜索
            is_m_search: false,
            //搜索字段
            searchVal: '',
            From: this.$route.query.From,
        };
    },
    //进入页面执行的函数
    created() {
        // this.getUser();
    },
    mounted() {
        console.log(this.is_PC)
    },
    methods: {
        //获取登录用户
        // getUser() {
        //     this.user = this.$store.state.login_user
        // },

        handleSelect(key, keyPath) {
            this.muenindex = key;
            this.drawer = false;
            this.$router.push({ path:'/'+ key })
        },

        //关闭抽屉
        handleClose(done) {
            done();
        },

        //跳转搜索页面
        toSearch() {
            // 为空搜索全部
            this.$store.commit('updateSearchVal', this.searchVal)
            this.$router.push({
                path: '/search'
            })
        },

        //移动端返回按钮
        returnBtn() {
            if (this.From) {
                this.$router.push({
                    path: this.From
                })
            } else {
                this.$router.back(-1)
            }

        },

    },
    computed: {
        onRoutes() {
            if (this.$route.meta.activeMenu) {
                return this.$route.meta.activeMenu
            }
            return this.$route.path;
        },
        //滚轮状态
        scrollType() {
            return this.$store.getters.getScrollType;
        },
        //登录状态
        loginType() {
            return this.$store.getters.getloginType;
        },
        //登录用户资料
        user() {
            if (this.$store.getters.get_login_user_data) {
                return this.$store.getters.get_login_user_data;
            } else {
                return JSON.parse(localStorage.getItem("user"));
            }
        },
        //学校信息
        enterprisesInformation() {
            if (this.$store.getters.get_enterprisesInformation) {
                return this.$store.getters.get_enterprisesInformation;
            } else {
                return JSON.parse(localStorage.getItem("Enterprises"));
            }
        },
        //是否显示返回上一级
        is_return() {
            return this.$store.getters.getIsReturn;
        },
        //从哪一页跳转过来
        // fromPage() {
        //     if (this.From == 'home') {
        //         return '/home';
        //     }
        // }
    },
    watch: {
        onRoutes(curVal, oldVal) {
            // this.getcurrentUserMsg()
        }
    },
}
</script>

<style scoped>
@import './header.css';


#header>>>.el-drawer__wrapper {
    height: 1vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;

}
</style>
